import { apiDev } from "./api";

export interface DropdownClassData {
  DataId: number;
  DataCode: string | null;
  DataCode2: string | null;
  DataCode3: string | null;
  DataLabel: string;
  Description: string | null;
}

export interface WorkPermitTypeResponse {
  dropdownClassDatas: DropdownClassData[];
  TotalRecord: number;
  Code: number;
  Message: string;
}

export interface TenantMallData {
  TenantId: number;
  BrandId: number;
  BrandName: string;
  MallId: number;
  MallName: string;
  Floor: string;
  Unit: string;
  Address: string;
  PICName: string | null;
  PICPhone: string | null;
  PICEmail: string | null;
  Status: number;
}

export interface TenantMallApiResponse {
  tenantMallDatas: TenantMallData[];
  TotalRecord: number;
  Code: number;
  Message: string;
}

export interface WorkPermitPersonnelData {
  WorkPermitPersonnelId?: number;
  WorkPermitHeaderId?: number;
  PersonnelName: string;
  IdentityNumber: string;
  PersonnelQRCode?: string | null;
  DataImage: string;
  IsAccessCard: number;
  IsParkingLotKey: number;
  FileImage?: string | null;
  ImageLabel: string;
  CheckInStatus?: number;
  Status?: number;
}

export interface WorkPermitItemData {
  WorkPermitItemId?: number;
  PermitTypeId: number;
  ItemQuantity: number;
  ItemUnit: string;
  Description: string;
  Status: number;
}

export interface PermitTypeActivity {
  PermitTypeId: number;
  ActivityMasterId: number;
}

export interface WorkPermitHeaderData {
  WorkPermitHeaderId?: number;
  PermitNumber?: string | null;
  PermitNumberHeader?: string | null;
  MallId: number;
  TenantId: number;
  TenantName: string;
  LotNo: string;
  VendorId?: number | null;
  VendorName?: string | null;
  PICName: string;
  PICAddress: string;
  PICPhone: string;
  StartOn: string;
  FinishOn: string;
  StartTime: string;
  FinishTime: string;
  Description?: string | null;
  PermitHeaderStatus?: number;
  PermitHeaderStatusDesc?: string;
  Status?: number;
  PermitTypeIds: number[];
  PermitTypeActivities: PermitTypeActivity[];
  personnelDatas: WorkPermitPersonnelData[];
  itemDatas: WorkPermitItemData[];
  ActivityMasterId: number;
  workPermitDatas: WorkPermitData[];
}

export interface SaveWorkPermitRequest {
  workPermitHeaderData: WorkPermitHeaderData;
}

export interface SaveWorkPermitResponse {
  Code: number;
  Message: string;
}

export const SaveWorkPermit = (request: SaveWorkPermitRequest) => {
  const url = "/tenant/v1/saveworkpermit";
  return apiDev.post<SaveWorkPermitResponse>(url, request);
};

export const GetWorkPermitType = (referenceid: number = 0) => {
  const url = `/dropdown/v1/getworkpermittype?referenceid=${referenceid}`;
  return apiDev.get<WorkPermitTypeResponse>(url);
};

export const GetTenantMall = (tenantId: number) => {
  const url = `/tenant/v1/gettenantmall?tenantid=${tenantId}&number=0&page=0`;
  return apiDev.get<TenantMallApiResponse>(url);
};

export const GetActivityMaster = (referenceid: number = 0) => {
  const url = `/dropdown/v1/getactivitymaster?referenceid=${referenceid}`;
  return apiDev.get<WorkPermitTypeResponse>(url);
};

export interface WorkPermitPersonnelListData {
  PersonnelName: string;
  IdentityNumber: string;
  IsAccessCard: number;
  IsParkingLotKey: number;
  FileImage?: string | null;
  ImageLabel?: string | null;
  PersonnelQRCode?: string | null;
}

export interface WorkPermitItemListData {
  WorkPermitItemId?: number;
  Description: string;
  ItemQuantity: number;
  ItemUnit: string;
  PermitTypeId?: number;
  Status?: number;
}

export interface WorkPermitData {
  WorkPermitId: number;
  WorkPermitHeaderId: number;
  PermitNumber: string;
  PermitTypeId: number;
  PermitTypeName: string;
  MallId: number;
  TenantId: number;
  TenantName: string;
  VendorId?: number | null;
  VendorName?: string | null;
  LotNo: string;
  PICName: string;
  PICPhone: string;
  PICAddress: string;
  StartOn: string;
  FinishOn: string;
  StartTime: string;
  FinishTime: string;
  Description?: string | null;
  PermitStatus: number;
  PermitStatusDesc: string;
  Status: number;
  ActivityMasterId?: number;
  ActivityMasterName?: string;
  CreatedOn?: string;
  UpdatedOn?: string;
  personnelDatas: WorkPermitPersonnelListData[];
  itemDatas: WorkPermitItemListData[];
}

export interface WorkPermitHeaderListData {
  WorkPermitHeaderId: number;
  PermitNumber?: string | null;
  PermitNumberHeader?: string | null;
  MallId: number;
  TenantId: number;
  TenantName: string | null;
  LotNo: string;
  VendorId?: number | null;
  VendorName?: string | null;
  PICName: string;
  PICAddress: string;
  PICPhone: string;
  StartOn: string;
  FinishOn: string;
  StartTime: string;
  FinishTime: string;
  Description?: string | null;
  PermitHeaderStatus: number;
  PermitHeaderStatusDesc?: string;
  Status: number;
  ActivityMasterId: number;
  PermitTypeIds: number[];
  PermitTypeActivities?: any;
  personnelDatas: WorkPermitPersonnelListData[];
  itemDatas: WorkPermitItemListData[];
  workPermitDatas: WorkPermitData[];
}

export interface GetWorkPermitResponse {
  workPermitHeaderDatas: WorkPermitHeaderListData[];
  TotalRecord: number;
  Code: number;
  Message: string;
}

export const GetWorkPermit = (
  workpermitid: number = 0,
  permittypeid: number = 0,
  permitstatus: number = 0,
  mallid: number,
  tenantid: number = 0,
  page: number = 0,
  number: number = 0
) => {
  const url = `/tenant/v1/getworkpermit?workpermitid=${workpermitid}&permittypeid=${permittypeid}&permitstatus=${permitstatus}&mallid=${mallid}&tenantid=${tenantid}&page=${page}&number=${number}`;
  return apiDev.get<GetWorkPermitResponse>(url).then((response) => response.data);
};